import { Button, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

import { AdminMenuLayout, ModalBrands, PageCard } from "../../../shared/components";
import { useBrands } from "../hooks";
import { selectModalBrands } from "../../../redux";
import { TableBrands } from "./TableBrands";

export const Brands = () => {
  const modalBrands = useSelector(selectModalBrands);
  const {
    isUpdateBrand,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalBrandsState,
  } = useBrands();

  return (
    <AdminMenuLayout pageDescription="Gestión de marcas" title="Marcas">
      <PageCard
        title="Listado de marcas"
        action={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={changeModalBrandsState}
          >
            Agregar nueva marca
          </Button>
        }
      >
        <TableBrands />
      </PageCard>

      {modalBrands && isUpdateBrand && (
        <FormProvider {...formMethodsUpdate}>
          <ModalBrands />
        </FormProvider>
      )}
      {modalBrands && !isUpdateBrand && (
        <FormProvider {...formMethodsCreate}>
          <ModalBrands />
        </FormProvider>
      )}
    </AdminMenuLayout>
  );
};

